import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue';
import { GoogleMap, } from "vue3-google-map";

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGoogle',
  setup(__props) {

let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const Markers = defineAsyncComponent(() => import("@/components/theme/maps/MarkersMap.vue"))
const DraggableMarker = defineAsyncComponent(() => import("@/components/theme/maps/DraggableMarker.vue"))
const GooglePolyline = defineAsyncComponent(() => import("@/components/theme/maps/GooglePolyline.vue"))
const TrianglePolygon = defineAsyncComponent(() => import("@/components/theme/maps/TrianglePolygon.vue"))
let desc = ref<string>("Display a map at a specified location and zoom level.")
let desc1 = ref<string>("Display a map with labels in a foreign language")
let desc2 = ref<string>("Display a map highlighting points of interest")
let desc3 = ref<string>("Display a map highlighting points of interest")
let desc4 = ref<string>("Display a map with a line showing a known route")
let desc5 = ref<string>("Display a map highlighting a region or area")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Map at a specified location",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(GoogleMap), {
            "api-key": "AIzaSyDGCQvcXUsXwCdYArPXo72dLZ31WS3WQRw",
            center: { lat: 20.5937, lng: 78.9629 },
            zoom: 12,
            style: {"width":"auto","height":"500px"}
          })
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Multi-language support",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc1)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(GoogleMap), {
            "api-key": "AIzaSyDGCQvcXUsXwCdYArPXo72dLZ31WS3WQRw",
            center: { lat: 20.5937, lng: 78.9629 },
            zoom: 6,
            style: {"width":"auto","height":"500px"},
            options: {
                        region: 'VI',
                        language: 'vi',
                    }
          })
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Marker on the Map",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc2)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Markers))
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Draggable Marker",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc3)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DraggableMarker))
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Polyline on the Map",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc4)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(GooglePolyline))
        ]),
        _: 1
      }, 8, ["desc"]),
      _createVNode(_unref(Card3), {
        colClass: "col-xl-6",
        cardbodyClass: "map-z-index",
        title: "Polygon on the Map",
        headerTitle: "true",
        text: "true",
        desc: _unref(desc5)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TrianglePolygon))
        ]),
        _: 1
      }, 8, ["desc"])
    ])
  ]))
}
}

})